type SurveyContainerProps = {
  children: React.ReactNode;
};

const SurveyContainer = ({ children }: SurveyContainerProps): JSX.Element => (
  <div className="flex flex-col w-full max-w-xl p-5">{children}</div>
);
export default SurveyContainer;
